<template>
  <v-container class="mt-4 ml-2" fluid>

    <v-row>
      <v-col cols="12">

        <v-card class="shadowCard">

          <!-- ================= HEADER ================= -->
          <v-card-title class="pb-2">
            <!-- Primera fila: título -->
            <div class="d-flex align-center justify-space-between mb-3" style="width: 100%;">
              <span class="text-subtitle-1 font-weight-bold">
                Administración Vacaciones Empleados
              </span>

              <!-- Boton de actualizar -->
              <v-btn color="primary" dark small rounded @click="initialize()" class="mr-2" >Actualizar</v-btn>
            </div>

            <!-- Segunda fila: Buscador y filtros -->
            <div class="d-flex align-center" style="width: 100%; gap: 12px;">
              <!-- Buscador general -->
              <v-text-field
                v-model="search"
                label="Buscar"
                prepend-inner-icon="mdi-magnify"
                dense
                hide-details
                outlined
                style="max-width: 300px;"
                clearable
              />

              <!-- Filtro por estatus -->
              <v-select
                v-model="filtroEstatus"
                :items="estatusFiltroItems"
                label="Filtrar por estatus"
                dense
                hide-details
                outlined
                style="max-width: 200px;"
                clearable
              />
            </div>
          </v-card-title>


          <!-- ================= TABLA ================= -->
          <v-data-table
            :headers="headers"
            :items="vacacionesFiltradas"
            :search="search"
            dense
          >

            <!-- JEFE -->
            <template v-slot:item.respuesta_jefe="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_jefe)"
                @click="abrirRespuesta(item,'jefe')"
              >
                {{ textoEstatus(item.respuesta_jefe) }}
              </v-chip>
            </template>

            <!-- RH -->
            <template v-slot:item.respuesta_rh="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_rh)"
                @click="abrirRespuesta(item,'rh')"
              >
                {{ textoEstatus(item.respuesta_rh) }}
              </v-chip>
            </template>

            <!-- ACCIONES -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="puedeEditarItem(item)"
                x-small color="primary" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                v-if="puedeEliminarItem(item)"
                x-small
                color="error"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>


    <!-- ================= DIALOG EDITAR/AGREGAR ================= -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>

        <v-card-title>
          {{ editedIndex === -1 ? 'Agregar Vacaciones' : 'Editar Vacaciones' }}
        </v-card-title>

        <v-card-text>

          <v-text-field
            v-model="editedItem.vacaciones"
            label="Vacaciones"
            filled dense
          />

          <v-autocomplete
            filled
            dense
            :clearable="puedeElegirOtroTrabajador"
            v-model="editedItem.idtrabajador"
            :items="trabajadores"
            label="Selecciona un trabajador"
            prepend-inner-icon="mdi-account"
            single-line
            item-text="nombre_completo"
            item-value="id_usuario"
            :disabled="!puedeElegirOtroTrabajador"
          />

          <v-text-field
            v-model="editedItem.fecha_inicio"
            label="Fecha Inicio"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.fecha_fin"
            label="Fecha Fin"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.dias_vacaciones"
            label="Días vacaciones"
            type="number"
            min="0"
            max="40"
            filled
            dense
            readonly
          />

        </v-card-text>

        <v-card-actions>
          <v-btn text @click="close">Cancelar</v-btn>
          <v-spacer/>
          <v-btn color="green" dark @click="save">Guardar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    <!-- ================= DIALOG RESPUESTA JEFE/RH ================= -->
    <v-dialog v-model="dialogRespuesta" max-width="400px">
      <v-card>

        <v-card-title>
          Respuesta {{ tipoRespuesta.toUpperCase() }}
        </v-card-title>

        <v-card-text>

          <v-select
            v-model="respuestaTemp"
            :items="estatusItems"
            label="Estatus"
            filled dense
          />

          <v-textarea
            v-if="respuestaTemp==2"
            v-model="motivoTemp"
            label="Motivo rechazo"
            filled dense
          />

        </v-card-text>

        <v-card-actions>
          <v-btn text @click="dialogRespuesta=false">Cancelar</v-btn>
          <v-spacer/>
          <v-btn color="green" dark @click="guardarRespuesta">
            Guardar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

export default {

  computed : {
		...mapGetters('login',['getdatosUsuarioERPERP']),

    puedeSolicitarVacaciones () {
      const usuario = this.getdatosUsuarioERPERP
      if (!usuario || !usuario.fecha_alta ) return false


      // 1) Si el iderp está en la lista de excepciones, puede solicitar
      if (this.iderpUsuariosTieneVacaciones.includes(usuario.iderp)) {
        return true
      }

      // 2) Validar que haya pasado al menos un año desde fecha_alta
      const fechaAltaStr = usuario.fecha_alta // "2025-07-30 09:51:00"
      const [fechaSolo] = fechaAltaStr.split(' ') // "2025-07-30"
      const fechaAlta = new Date(fechaSolo)
      if (isNaN(fechaAlta)) return false

      const hoy = new Date()
      const unAnioDespues = new Date(fechaAlta)
      unAnioDespues.setFullYear(unAnioDespues.getFullYear() + 1)

      return hoy >= unAnioDespues
    },

    puedeElegirOtroTrabajador () {
      const iderp = this.getdatosUsuarioERPERP.iderp

      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderp)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(iderp)

      return esJefePermitido || esRHPermitido
    },

    vacacionesFiltradas () {
      if (this.filtroEstatus === null || this.filtroEstatus === undefined) {
        return this.vacaciones
      }

      const estatus = Number(this.filtroEstatus)

      // Mostrar registros donde Jefe o RH tengan ese estatus
      return this.vacaciones.filter(item =>
        item.respuesta_jefe === estatus ||
        item.respuesta_rh === estatus
      )
    },

	},

  data: () => ({

    dialog:false,
    dialogRespuesta:false,

    vacaciones:[],
    trabajadores: [],
    iderpUsuariosTieneVacaciones: [], // solo para pruebas, los iderp que esten aquí podrán solicitar vacaciones
    iderpUsuariosPermitidosJefe: [],
    iderpUsuariosPermitidosRH: [ 68 ],
    diasDisponibles: null,
    
    search:'',
    filtroEstatus: 0,
    estatusFiltroItems: [
      { text: 'Todos',    value: null },
      { text: 'Pendiente', value: 0 },
      { text: 'Aceptado',  value: 1 },
      { text: 'Rechazado', value: 2 },
    ],

    headers:[
      { text:'ID', value:'idvacaciones' },
      { text:'Vacaciones', value:'vacaciones' },
      { text:'Empleado', value:'nombre_completo' },
      { text:'Fecha Inicio', value:'fecha_inicio' },
      { text:'Fecha Fin', value:'fecha_fin' },
      { text:'Días vacaciones', value:'dias_vacaciones' }, // ← NUEVA COLUMNA
      { text:'Prima', value:'prima_vacaciones' }, // ← NUEVA COLUMNA
      { text:'Jefe', value:'respuesta_jefe' },
      { text:'RH', value:'respuesta_rh' },
      { text:'Motivo Rechazo', value:'motivo_rechazo' },
      { text:'Actions', value:'actions', sortable:false }
    ],

    editedIndex:-1,

    editedItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    defaultItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    /* ===== respuesta rápida ===== */
    tipoRespuesta:'',
    itemRespuesta:null,
    respuestaTemp:0,
    motivoTemp:'',

    estatusItems:[
      { text:'Pendiente', value:0 },
      { text:'Aceptado', value:1 },
      { text:'Rechazado', value:2 }
    ]

  }),

  async created(){

    await this.obtenerDiasDisponibles()
    await this.getTrabajadores()
    this.initialize()
  },

  watch: {
    'editedItem.fecha_inicio': 'actualizarDiasVacaciones',
    'editedItem.fecha_fin'   : 'actualizarDiasVacaciones',
  },
  
  
  
  methods:{

    obtenerDiasDisponibles () {
      // getDiasDisponibles
      return this.$http
      .get(`vacaciones.get.dias.disponibles/${ this.getdatosUsuarioERPERP.iderp }`).then(response => {
        this.diasDisponibles = response.data.dias_disponibles || 0
        console.log( '///////////////' )
        console.log( this.diasDisponibles )
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    esJefe( id ) {

      this.cargar = true

      return this.$http
      .get(`vacaciones.es.jefe.directo/${id}`).then(response => {
        //console.log( this.getdatosUsuarioERPERP.idpuesto === response.data.id_puesto_jefe )
          return response.data.id_puesto_jefe
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    getTrabajadores () {
      this.cargar = true
      this.trabajadores = []

      console.log( this.getdatosUsuarioERPERP )

      return this.$http.get('vacaciones.get.trabajadores', {
        params: {
          id_puesto: this.getdatosUsuarioERPERP.idpuesto
        }
      })
        .then(response => {
          this.trabajadores = response.data.trabajadores
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    initialize(){
      console.log( this.getdatosUsuarioERPERP )
      this.$http.get('vacaciones.list')
        .then(r=> this.vacaciones=r.data)
    },

    save () {
    const esEdicion = this.editedIndex > -1

    const req = esEdicion
      ? this.$http.put('vacaciones.update/' + this.editedItem.idvacaciones, this.editedItem)
      : this.$http.post('vacaciones.add', this.editedItem)

    req.then(() => {
      this.$swal({
        icon: 'success',
        title: esEdicion ? 'Solicitud actualizada' : 'Solicitud registrada',
        text: esEdicion
          ? 'La solicitud de vacaciones se actualizó correctamente.'
          : 'La solicitud de vacaciones se agregó correctamente.',
        confirmButtonText: 'Aceptar'
      })

      this.close()
      this.initialize()
      this.obtenerDiasDisponibles()
    }).catch(error => {
      const mensaje =
      error.response.data.message ||
      'Ocurrió un error al guardar la solicitud de vacaciones.'

      this.$swal({
        icon: 'error',
        title: 'Error',
        text: mensaje,
        confirmButtonText: 'Aceptar'
      })
    })
    },

    abrirDialogSolicitud () {
      // Reiniciar formulario a valores por defecto (modo "agregar")
      this.editedIndex = -1
      this.editedItem  = { ...this.defaultItem }

      
      const iderpUsuario = this.getdatosUsuarioERPERP.iderp

      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderpUsuario)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

      // Si NO es jefe permitido NI RH permitido, se autoselecciona él mismo
      if (!esJefePermitido && !esRHPermitido) {
        const trabajadorActual = this.trabajadores.find(
          t => t.id_usuario === iderpUsuario
        )

        if (trabajadorActual) {
          // El autocomplete usa item-value="id_usuario", y tu modelo es editedItem.idtrabajador
          this.editedItem.idtrabajador = trabajadorActual.id_usuario
        }
      }

      this.dialog = true
    },

    /* ================= RESPUESTAS ================= */

    async abrirRespuesta (item, tipo) {
    
    // 1) Consultar el id_puesto_jefe desde el back
    const idPuestoJefe = await this.esJefe(item.idtrabajador)

    if (idPuestoJefe === null) {
      // Hubo error en la petición, ya se mostró en validarError
      return
    }

    // 2) Calcular permiso
    const esUsuarioPermitidoJefe = this.getdatosUsuarioERPERP.idpuesto === idPuestoJefe || this.iderpUsuariosPermitidosJefe.includes(this.getdatosUsuarioERPERP.iderp)
    const esUsuarioPermitidoRH   = this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

    let tienePermiso = false

    if (tipo === 'jefe') {
      // Puede responder como jefe si es el jefe directo o está en la lista de jefes permitidos
      tienePermiso = esUsuarioPermitidoJefe
    } else if (tipo === 'rh') {
      // Puede responder como RH si está en la lista de RH permitidos
      tienePermiso = esUsuarioPermitidoRH
    }

    // 3) Si no tiene permisos, mostrar mensaje y salir
    if (!tienePermiso) {
        this.$swal({
        icon: 'error',
        title: 'Sin permisos',
        text: 'No tiene permisos para realizar esta acción',
        confirmButtonText: 'Aceptar'
      })
      
      return
    }

    // 4) Validación extra para RH (que el jefe ya haya respondido)
    if (tipo === 'rh' && item.respuesta_jefe === 0) {
      this.$swal({
        icon: 'warning',
        title: 'Sin respuesta del jefe',
        text: 'El jefe directo aún no ha respondido la solicitud',
        confirmButtonText: 'Aceptar'
      })
    }

    // 5) Si tiene permisos, abrir la modal
    this.itemRespuesta = item
    this.tipoRespuesta = tipo
    this.respuestaTemp = tipo === 'jefe' ? item.respuesta_jefe : item.respuesta_rh
    this.motivoTemp    = item.motivo_rechazo || ''
    this.dialogRespuesta = true
  },

    guardarRespuesta(){

      if(this.respuestaTemp==2 && !this.motivoTemp){
        return alert('Debes escribir el motivo')
      }

      const payload={...this.itemRespuesta}

      if(this.tipoRespuesta==='jefe'){
        payload.respuesta_jefe=this.respuestaTemp
      }else{
        payload.respuesta_rh=this.respuestaTemp
      }

      payload.motivo_rechazo=this.motivoTemp

      this.$http.put('vacaciones.update/'+payload.idvacaciones,payload)
        .then(()=>{
          this.dialogRespuesta=false
          this.initialize()
        })
    },


    /* ================= UI ================= */

    editItem(item){
      this.editedIndex=this.vacaciones.indexOf(item)
      this.editedItem={...item}
      this.dialog=true
    },

     deleteItem (item) {
    this.$swal({
      title: '¿Eliminar solicitud?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.$http
          .put('vacaciones.eliminar/' + item.idvacaciones)
          .then(() => {
            this.$swal({
              icon: 'success',
              title: 'Eliminada',
              text: 'La solicitud de vacaciones fue eliminada correctamente.',
              confirmButtonText: 'Aceptar'
            })
            this.initialize()
            this.obtenerDiasDisponibles()
          })
          .catch(error => {
            this.validarError(error.response.data.message)
          })
      }
    })
  },

    close(){
      this.dialog=false
      this.editedItem={...this.defaultItem}
      this.editedIndex=-1
    },


    /* helpers visuales */
    textoEstatus(v){
      return ['Pendiente','Aceptado','Rechazado'][v]
    },

    colorEstatus(v){
      return ['grey','green','red'][v]
    },

    actualizarDiasVacaciones () {
      const inicio = this.editedItem.fecha_inicio
      const fin    = this.editedItem.fecha_fin

      if (!inicio || !fin) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      // Parsear como fecha local, no como UTC
      const [y1, m1, d1] = inicio.split('-').map(Number)
      const [y2, m2, d2] = fin.split('-').map(Number)

      const fechaInicio = new Date(y1, m1 - 1, d1)
      const fechaFin    = new Date(y2, m2 - 1, d2)

      if (isNaN(fechaInicio) || isNaN(fechaFin) || fechaFin < fechaInicio) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      let dias = 0
      const cursor = new Date(fechaInicio)

      while (cursor <= fechaFin) {
        const esDomingo = cursor.getDay() === 0 // 0 = domingo
        if (!esDomingo) {
          dias++
        }
        cursor.setDate(cursor.getDate() + 1)
      }

      this.editedItem.dias_vacaciones = dias
    },

    puedeEditarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp

      // Solo se puede editar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh   === 0

      if (!siguePendiente) return false

      const esJefeORH =
        this.iderpUsuariosPermitidosJefe.includes(iderp) ||
        this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

      const esSuPropiaSolicitud = item.idtrabajador === iderp

      return esJefeORH || esSuPropiaSolicitud
    },

    puedeEliminarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp
      if (!iderp) return false

      // Solo se puede eliminar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh === 0

      if (!siguePendiente) return false

      // Puede eliminar si es RH o Jefe permitido
      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderp)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(iderp)

      // O si es el creador de la solicitud
      const esSuPropiaSolicitud = item.idtrabajador === iderp || item.id_usuario === iderp

      return esJefePermitido || esRHPermitido || esSuPropiaSolicitud
    },

  }
}
</script>


<style scoped>
.pointer{
  cursor:pointer;
}
</style>
